import { useState, FormEvent } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import BreadcrumbNav from '@/components/base/BreadcrumbNav';
import SEOSchema from '@/components/feature/SEOSchema';

const testimonials = [
  {
    name: '小雨',
    text: '自从发现了韩国漫画在线，我的通勤时间变得有趣多了！下拉式阅读体验超棒，漫画分类也很全，强烈推荐给所有韩漫爱好者。',
    rating: 5,
  },
  {
    name: '星辰大海',
    text: '这个韩漫网站的漫画更新速度很快，画质也很清晰。特别喜欢恋爱分类的漫画，每天都要看几话才睡得着！',
    rating: 5,
  },
  {
    name: 'Miko',
    text: '界面简洁好看，没有烦人的广告弹窗。下拉式韩漫大全功能让阅读体验非常流畅，是我用过最好的免费漫画阅读平台。',
    rating: 5,
  },
  {
    name: '风一样自由',
    text: '奇幻分类的漫画太精彩了！异世界冒险谭和龙之继承者都是我的最爱。感谢韩国漫画在线提供这么多优质的免费韩漫资源。',
    rating: 4,
  },
  {
    name: '樱花树下的猫',
    text: '日常分类的漫画特别治愈，猫的咖啡馆和独自生活都是必看之作。网站的阅读体验也很棒，强烈推荐！',
    rating: 5,
  },
  {
    name: 'Lucas',
    text: '作为一个韩漫新手，这个网站的分类和推荐功能帮我快速找到了喜欢的漫画。界面友好，阅读体验流畅，非常满意。',
    rating: 4,
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    formData.delete('phone_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9ped3li2vhsdh2d32ig', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormError('');
        form.reset();
      } else {
        const serverMsg =
          parsed?.meta?.message ||
          parsed?.message ||
          parsed?.meta?.detail ||
          responseText ||
          '提交失败，请稍后重试';
        setFormStatus('error');
        setFormError(serverMsg);
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <>
      <ScrollToTop />
      <SEOSchema
        pageType="AboutPage"
        pageTitle="关于我们 - 韩国漫画在线 | 韩漫网站"
        pageDescription="了解韩国漫画在线——专注免费韩国漫画阅读的平台。提供品牌介绍、用户口碑和联系方式，致力于为韩漫爱好者提供优质的在线阅读体验。"
        canonicalUrl="https://koreancomics.cn/about"
        breadcrumbItems={[
          { label: '首页', to: '/' },
          { label: '关于我们' },
        ]}
      />
      <Navbar />
      <main className="pt-16">
        <div className="px-4 md:px-6 py-6 md:py-8">
          <BreadcrumbNav
            items={[
              { label: '首页', to: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mt-6 md:mt-8 max-w-4xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">
              关于韩国漫画在线
            </h1>
            <p className="text-sm text-foreground-500 mt-2">
              您的专属韩漫阅读伙伴
            </p>

            <div className="mt-6 md:mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
              <div className="lg:col-span-2">
                <div className="space-y-5">
                  <div>
                    <h2 className="text-lg font-heading text-foreground-900 mb-3">
                      品牌故事
                    </h2>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      韩国漫画在线成立于2024年，是一个专注于韩国漫画（韩漫）的免费阅读平台。
                      我们致力于为广大中文读者提供高品质、便捷的韩国漫画阅读体验。
                      平台汇集了超过数百部韩国漫画作品，涵盖<span className="font-medium text-foreground-800">恋爱、奇幻、动作、悬疑、日常</span>五大核心分类。
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                      我们深知高质量阅读体验的重要性，因此打造了下拉式韩漫大全功能——
                      采用韩国漫画独特的竖向滚动阅读方式，让每一页漫画画面连贯流畅，
                      为用户带来沉浸式的漫画阅读享受。
                    </p>
                  </div>

                  <div>
                    <h2 className="text-lg font-heading text-foreground-900 mb-3">
                      我们的使命
                    </h2>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      让每一位韩漫爱好者都能轻松找到自己喜欢的韩国漫画，享受免费的阅读体验。
                      我们持续追踪最新的韩漫更新，确保用户不会错过任何精彩内容。
                      韩国漫画在线——韩漫网站的首选平台。
                    </p>
                  </div>

                  <div>
                    <h2 className="text-lg font-heading text-foreground-900 mb-3">
                      核心优势
                    </h2>
                    <ul className="space-y-2">
                      {[
                        { icon: 'ri-checkbox-circle-line', text: '完全免费：所有韩国漫画均可免费阅读，无隐藏收费' },
                        { icon: 'ri-smartphone-line', text: '下拉式阅读：完美支持手机竖屏阅读体验' },
                        { icon: 'ri-speed-up-line', text: '更新迅速：每日追踪最新韩漫更新' },
                        { icon: 'ri-layout-grid-line', text: '分类齐全：五大分类覆盖所有韩漫类型' },
                        { icon: 'ri-shield-check-line', text: '安全可靠：无恶意广告，保护用户隐私' },
                      ].map((item, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm text-foreground-600">
                          <i className={`${item.icon} text-primary-500 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0`}></i>
                          <span>{item.text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              <div>
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                  <h3 className="font-heading text-base text-foreground-900 mb-4">
                    网站数据
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <div className="text-2xl font-heading text-primary-500">200+</div>
                      <div className="text-xs text-foreground-500 mt-0.5">收录漫画作品</div>
                    </div>
                    <div>
                      <div className="text-2xl font-heading text-accent-500">10万+</div>
                      <div className="text-xs text-foreground-500 mt-0.5">月活跃读者</div>
                    </div>
                    <div>
                      <div className="text-2xl font-heading text-primary-500">5大</div>
                      <div className="text-xs text-foreground-500 mt-0.5">漫画分类</div>
                    </div>
                    <div>
                      <div className="text-2xl font-heading text-accent-500">每日</div>
                      <div className="text-xs text-foreground-500 mt-0.5">内容更新</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="mt-10 md:mt-14 max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-2">
              读者口碑
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-6 md:mb-8">
              来自韩漫爱好者的真实评价
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {testimonials.map((t, i) => (
                <div
                  key={i}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, starIdx) => (
                      <i
                        key={starIdx}
                        className={`ri-star-fill text-xs w-3 h-3 flex items-center justify-center ${
                          starIdx < t.rating ? 'text-accent-400' : 'text-background-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    "{t.text}"
                  </p>
                  <p className="text-xs text-foreground-400 mt-3 font-medium">
                    — {t.name}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <section className="mt-10 md:mt-14 max-w-2xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-2">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-6 md:mb-8">
              有任何问题或建议？欢迎随时联系我们
            </p>

            <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6">
              <form
                onSubmit={handleSubmit}
                data-readdy-form=""
                id="contact-form"
                className="space-y-4"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      姓名
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      邮箱
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    主题
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    required
                    className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                    placeholder="请输入消息主题"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    留言内容
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                    placeholder="请输入您的留言内容（最多500字）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                </div>

                <div className="honeypot-wrapper">
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                </div>

                <button
                  type="submit"
                  className="w-full sm:w-auto px-8 py-2.5 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  发送消息
                </button>

                {formStatus === 'success' && (
                  <p className="text-sm text-green-600 mt-2">
                    消息已成功发送！我们会尽快回复您。
                  </p>
                )}
                {formStatus === 'error' && (
                  <p className="text-sm text-red-500 mt-2">
                    {formError}
                  </p>
                )}
              </form>
            </div>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
              <div className="p-4 bg-background-50 border border-background-200/70 rounded-lg">
                <i className="ri-mail-line text-xl text-primary-500 w-5 h-5 flex items-center justify-center mx-auto"></i>
                <p className="text-sm text-foreground-700 mt-2 font-medium">电子邮箱</p>
                <p className="text-xs text-foreground-500 mt-0.5">support@koreancomics.cn</p>
              </div>
              <div className="p-4 bg-background-50 border border-background-200/70 rounded-lg">
                <i className="ri-customer-service-2-line text-xl text-primary-500 w-5 h-5 flex items-center justify-center mx-auto"></i>
                <p className="text-sm text-foreground-700 mt-2 font-medium">客服时间</p>
                <p className="text-xs text-foreground-500 mt-0.5">周一至周五 9:00-18:00</p>
              </div>
              <div className="p-4 bg-background-50 border border-background-200/70 rounded-lg">
                <i className="ri-map-pin-line text-xl text-primary-500 w-5 h-5 flex items-center justify-center mx-auto"></i>
                <p className="text-sm text-foreground-700 mt-2 font-medium">公司地址</p>
                <p className="text-xs text-foreground-500 mt-0.5">韩国首尔特别市江南区</p>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}